import { render } from "./GiftCampaignTriggerList.vue?vue&type=template&id=5a5f43e0"
import script from "./GiftCampaignTriggerList.vue?vue&type=script&lang=js"
export * from "./GiftCampaignTriggerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__